'use strict';

angular.module('ClinicApp').directive('appointmentCalendar', function($state, $q, appointmentOrganizerGroups, AppointmentService, OCAppointmentUtil) {
  return {
    scope: {
      modelType: '=',
      modelId: '=',
    },
    templateUrl: '/views/directives/_appointment-calendar.html',
    controller: function($scope) {
      var isMobile = window.innerWidth <= 480;
      var appointmentsCache = {};

      // https://fullcalendar.io/docs/
      $scope.config = {
        height: 600,
        editable: false,
        header: {
          left: 'prev,next',
          center: 'title',
          right: isMobile ? '' : 'month,agendaWeek,agendaDay',
        },
        defaultView: isMobile ? 'agendaDay' : 'agendaWeek',
        eventClick: eventClickHandler,
        viewRender: viewRenderHandler,
      };
      $scope.eventSources = [];

      function eventClickHandler(event) {
        var organizerGroup = _.find(appointmentOrganizerGroups, function(group) {
          return group.filter(event.appointment);
        });
        var isDentalAppointment = OCAppointmentUtil.isDentalAppointment(event.appointment);
        var state = $scope.modelType + '.appointment' + (isDentalAppointment ? '' : 'Legacy');
        $state.go(state, {
          id: $scope.modelId,
          tab: _.get(organizerGroup, 'name'),
          page: 1,
          appointmentId: event.appointment.id,
          backTo: 'Calendar',
        });
      }

      function viewRenderHandler(view) {
        _.remove($scope.eventSources);
        loadAppointments(view.start, view.end)
          .then((appointments) => {
            const events = _.map(appointments, (appointment) => {
              const date = moment(appointment.date).utc()
                .startOf('day');
              return {
                id: appointment.id,
                title: appointment.patient.firstName + ' ' + appointment.patient.lastName,
                start: moment(date).add(appointment.startTime, 'minutes'),
                end: moment(date).add(appointment.startTime + appointment.duration, 'minutes'),
                className: 'fc-event-' + appointment.status.toLowerCase(),
                appointment: appointment,
              };
            });
            $scope.eventSources.push({
              events: events,
            });
          })
          .finally(() => {
            $scope.loading = false;
          });
      }

      function loadAppointments(from, to) {
        var cacheKey = from.format('YYYYMMDD') + '_' + to.format('YYYYMMDD');
        if (appointmentsCache[cacheKey]) {
          return $q.when(appointmentsCache[cacheKey]);
        }
        $scope.loading = true;
        return AppointmentService.listAppointmentsForCalendar(
          $scope.modelType,
          $scope.modelId,
          from,
          to,
        )
          .then((appointments) => {
            appointmentsCache[cacheKey] = appointments;
            return appointments;
          });
      }
    },
  };
});
